module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-9.dd824f94.svg";